/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import React, {useCallback, useEffect, useContext, useReducer, useState} from 'react';
import {Link} from 'react-router-dom';
import OrgDetail from '../AdminTable/OrgDetail';

// export file - kb
import './TableComponent.scss';
import {MONTHNAMES} from '../../constants/index';
import {Context} from '../../context/dataStore';
import {Context_role} from '../../context/rolesStore';
import SearchBar from '../../components/DataLookUp/DataLookUp';
import {dataReducer} from '../../components/Reducers/index';
import {AnimatedEllipsis} from '../../components';
import compareValues from '../../constants/sort';
import {removeSpace} from '../../utils/utils';
import { SUBMITTER_ROLE , NOTAVAILABLE} from '../../constants/global';
import { RenderBody } from '../../components/AdminTable/TableUtils'; 

export default function MultipleOrganizations(props) {
  const {tableheaders} = props;
  const DEFAULT_STATE = {orderingStatus: ['none','none','none', 'none'], holder: [], ordering:[false, false, false, false], tableData:[], dataSurvey:[], metaValues:[],
    glyicon:['cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort'], errorMessage:''};
  const [state, dispatcher] = useReducer(dataReducer, DEFAULT_STATE);
  const [loading, setLoading] = useState(false);
  const {orderingStatus, ordering, tableData, dataSurvey, metaValues, glyicon} = state;

  //context data
  const {dispatch, state: {metaDataAboutUser, orgData}} = useContext(Context);
  const {state: {orgid_roles, newroles}} = useContext(Context_role);

  //align data
  const alignData = resu => {
    //get the oids out in O(n);
    const oids = [];
    orgid_roles.forEach(({rid, oid}) => {
      newroles.forEach(el => {
        if(rid===el) {
          oids.push(parseInt(oid));
        }
      });
    });
    const temp = [];
    //the oids is used to parse the array to match
    //uniqOID - will replace [163, 83, 96, 159, 60] once role id changed, hence making it dynamic
    resu.forEach(el => {
      if(oids.includes(el.org_id)) {
        temp.push(el);
      }
    });
    dispatcher({type:'SET_TABLE_DATA', payload: temp});
  };
  // load data
  useEffect(() => {
    alignData(orgData);
    if(orgData && orgData.length > 0) {
      setLoading(true);
    }
  }, [orgData]);

  /**
   * This function is used as callback to updated
   * the table data as you filter the search bar
   */
  const updateTableData = useCallback(datasentback => {
    dispatcher({type:'SET_TABLE_DATA', payload: datasentback});
    dispatcher({type:'SET_META_VALUE', payload: datasentback});
  }, [dispatcher]);

  /**
   * this is used to sort the table
   */
  const sortTable = useCallback((colindex, coldata, order, metadata) => {
    /**
     * metadata changes has you enter a character in the search bar. If nothing is entered
     * coldata will be used.
     */
    const datausedtosort = metadata.length===0?coldata:metadata;
    const ordertype = order===true?'asc':'desc';
    //--0:org_name, 1:org_id, 2:state, ...
    switch (colindex) {
      case 0:
        updateTableData(datausedtosort.sort(compareValues('org_name', ordertype)));
        break;
      case 1:
        updateTableData(datausedtosort.sort(compareValues('org_id', ordertype)));
        break;
      case 2:
        updateTableData(datausedtosort.sort(compareValues('state', ordertype)));
        break;
      case 3:
        updateTableData(datausedtosort.sort(compareValues('zone_name', ordertype)));
        break;
      default:
        break;
    }
  }, []);

  /**
   * headers - array of strings
   * combined with sorting feeatures
   * @param {array} param0
   */
  // maybe in a new file - kb
  const RenderHeader = ({headers, coldata, metdav}) => (
    <thead>
      <tr>
        {headers.map((head, index) => (
          <th scope='col' aria-sort={orderingStatus[index]} className='tableheadernonadmin cb-table-sort-joined' id={removeSpace(`th${index}id`)} key={head}>
              <Link to='#' onClick={() => {
                let newOrderingStatus = ['none','none','none'];
                ordering[index] = !ordering[index];
                if(ordering[index]===true) {
                  glyicon[index]='cb-icon cb-sort-asc';
                  newOrderingStatus[index] = 'ascending';
                } else {
                  glyicon[index]='cb-icon cb-sort-desc';
                  newOrderingStatus[index] = 'descending';
                }
                dispatcher({type:'SET_ORDERING_STATUS', payload: newOrderingStatus});
                glyicon.forEach((el, arr_ind) => {
                  if(index!==arr_ind) {
                    glyicon[arr_ind] = 'cb-icon cb-sort';
                  }
                });
                sortTable(index, coldata, ordering[index], metdav);
              }}
            >
              <span> {head} </span>
              <span aria-hidden='true' id={`tabler${index}clickheader`} className={`${glyicon[index]}`}>
              </span>
            </Link>
          </th>
        ))}
        <th scope='col' className='tableheader tableexpandheader'/> 
      </tr>
    </thead>
  );

  //--onclick call action to pass the name of clicked org
  const onclickAction = useCallback((val, id) => {
    dispatch({type:'UPDATE_METADATA', payload: {...metaDataAboutUser, orgName: val, orgId: id, org_role: newroles[0], legalNotice: false}});
  }, [metaDataAboutUser]);
  // maybe in a new file - kb
  const renderTableBody = () => {
    const [expandedOrg, setExpandedOrg] = React.useState(null);
    return (tableData.length===0?metaValues:tableData).map((row, index) => {
      let temp_rol = ''; //used to get the role for the org
      orgid_roles.forEach(({rid, oid}) => {
        if(row.org_id === parseInt(oid)) {
          if(temp_rol === '' || temp_rol !== SUBMITTER_ROLE) {
            temp_rol = rid; //'2014'
          } // it will always be same if the same institution
        }
      });
      return (
        (<RenderBody key={index} rowIndex={index} row={[
          <span style={{width: "100%"}} key={`${row.org_name}`}>
            <Link onClick={() => onclickAction(row.org_name, row.org_id)}
              to={`/organizations/${row.org_id}/categories/${0}/${temp_rol}`} 
              className='btnedit' id={`btn_${row.id}`}>
              <p>{row.org_name}</p>
            </Link>
          </span>,
          `${row.org_id}`,
          `${row.state?row.state:''}`,
          `${row?.zone_name || NOTAVAILABLE}`,
        ]} orgId={row.org_id} expandedOrg={expandedOrg} setExpandedOrg={setExpandedOrg} />)
      );
    })
  };
  // maybe in a new file - kb
  const RenderTable = () => (
    (
      <div className='cb-scrollbar-container'>
        <div className='cb-scrollbar cb-top'>
          <div className='cb-scrollbar-thumb' />
        </div>
        <div className='cb-table-responsive'>
          <table className='cb-table cb-table-condensed'>
            <caption style={{width: 'max-content'}}>Big Future College Profile</caption>
            <RenderHeader headers={tableheaders} coldata={orgData} metdav={metaValues} />
            <tbody>
              {
                (tableData.length===0 && metaValues.length===0)?<tr><td colSpan='5'><span id='nomatchingrecords_nonadmin'>No matching records found</span></td></tr>:renderTableBody()
              }
            </tbody>
          </table>
        </div>
        <div className='cb-scrollbar cb-bottom'>
          <div className='cb-scrollbar-thumb' />
        </div>
      </div>
    )
  );
  return(
    <div className='multiorg_container'>
      <div className='container_org_select' style={{alignSelf: 'stretch'}}>
        <div className='toplevel' style={{marginBottom: '20px'}}>
          <SearchBar searchData={orgData} actionDataSentBack={updateTableData} />
        </div>
        {
          !loading?
            <div className='centerEllipsis'><AnimatedEllipsis /></div>:
            <RenderTable />
        }
      </div>
    </div>
  );
}

MultipleOrganizations.propTypes = {
  tableheaders: PropTypes.array,
  headers: PropTypes.array,
  coldata:PropTypes.array,
  metdav:PropTypes.array,
  row:PropTypes.array
};